// extracted by mini-css-extract-plugin
export default {"container":"accountCopyLink_container__W8yUi","item":"accountCopyLink_item__Waktf","linkText":"accountCopyLink_linkText__3cPIQ"};